import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
const _ = require('lodash')

// helpers
function receiptItemsFromUserLoyaltyProgram (userLoyaltyArr) {
  return userLoyaltyArr
    .filter(program => program.receipts.length > 0)
    .reduce((flat, program, idx, src) => {
      program.receipts.forEach(receipt => {
        receipt.receiptItems.forEach((rI) => {
          flat.push({
            user: program.user,
            receiptId: receipt._id,
            receiptNumber: receipt.receiptNumber,
            date: receipt.dateOfPurchase,
            ...rI
          })
        })
      })
      return flat
    }, [])
}

const state = {
  program: {
    company: {
      logo: {
        url: null
      }
    },
    registrationForm: {
      formItems: []
    },
    slug: '',
    loyaltyProgramTrainings: [],
    userLoyaltyPrograms: []
  },
  programs: [],
  receipts: [],
  receiptItems: [],
  status: ''
}

const mutations = {
  REQUEST (state) {
    state.status = 'loading'
  },
  SUCCESS (state) {
    state.status = 'success'
  },
  ERROR (state, error) {
    state.status = 'error'
  },
  DISABLE_PROGRAM (state, id) {
    const index = state.programs.findIndex(program => program._id === id)
    const clone = _.cloneDeep(state.programs)
    clone[index].disabled = true
    state.programs = clone
  },
  ENABLE_PROGRAM (state, id) {
    const index = state.programs.findIndex(program => program._id === id)
    const clone = _.cloneDeep(state.programs)
    clone[index].disabled = false
    state.programs = clone
  },
  REMOVE_PROGRAM (state, id) {
    state.programs = state.programs.filter(program => program._id !== id)
  },
  SET_PROGRAM (state, program) {
    state.status = 'success'
    state.program = program
  },
  SET_PROGRAMS (state, programs) {
    state.status = 'success'
    state.programs = programs
  },
  SET_RECEIPTS_FROM_PROGRAM (state, receipts) {
    state.receipts = receipts
  },
  SET_RECEIPT_ITEMS_FROM_PROGRAM (state, receiptItems) {
    state.receiptItems = receiptItems
  },
  UPDATE_PROGRAM (state, payload) {
    state.program[payload.prop] = payload.value
  },
  UPDATE_PROGRAM_REBATE_ITEM (state, payload) {
    if (payload.prop) {
      state.program.rebateItems[payload.index][payload.prop] = payload.value
    } else {
      state.program.rebateItems[payload.index] = payload.value
    }
  },
  SET_FORM (state, form) {
    state.program.registrationForm.formItems = form
  },
  ADD_TO_FORM (state, item) {
    state.program.registrationForm.formItems.push(item)
  },
  REMOVE_FROM_FORM (state, index) {
    state.program.registrationForm.formItems.splice(index, 1)
  }
}

const actions = {
  createProgram ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/create`)
        .then(response => {
          commit('SET_PROGRAM', response.data.program)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  resetProgram ({ commit }) {
    commit('SET_PROGRAM', {})
  },
  getPrograms ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/list`)
        .then(response => {
          commit('SET_PROGRAMS', response.data.programs)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getProgramUpdate ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${state.program._id}/update`)
        .then(response => {
          commit('SET_PROGRAM', response.data.program)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  saveProgram ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.program._id) {
        reject(new Error('Program ID is undefined!'))
      }
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${state.program._id}/update`, state.program)
        .then(response => {
          commit('SUCCESS')
          commit('SET_PROGRAM', response.data.program)
          resolve(response.data.program)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  deleteProgram ({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.delete(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${id}/delete`)
        .then(response => {
          commit('SUCCESS')
          commit('REMOVE_PROGRAM', id)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  disableProgram ({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${id}/disable`)
        .then(response => {
          commit('SUCCESS')
          commit('DISABLE_PROGRAM', id)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  enableProgram ({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${id}/enable`)
        .then(response => {
          commit('SUCCESS')
          commit('ENABLE_PROGRAM', id)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  updateForm ({ commit }, payload) {
    if (payload.add) commit('ADD_TO_FORM', payload.content)
    else commit('REMOVE_FROM_FORM', payload.content)
  },
  saveForm ({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/form/create`, { programID: state.program._id, form: JSON.stringify(state.registrationForm) })
        .then(response => {
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getLoyaltyProgramBySlug ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/common/program/${encodeURI(slug)}`)
        .then(response => {
          commit('SET_PROGRAM', response.data.program)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getReceiptsByLoyaltyProgramId ({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${id}/receipts`)
        .then(response => {
          commit('SUCCESS')
          // console.log(response.data)
          const receipts = response.data.loyaltyProgram.userLoyaltyPrograms
            .reduce((flattened, ulp) => {
              ulp.receipts.forEach(receipt => {
                flattened.push({
                  user: ulp.user,
                  ...receipt
                })
              })
              return flattened
            }, [])
          commit('SET_RECEIPTS_FROM_PROGRAM', receipts)
          const result = receiptItemsFromUserLoyaltyProgram(response.data.loyaltyProgram.userLoyaltyPrograms)
          commit('SET_RECEIPT_ITEMS_FROM_PROGRAM', result)
          resolve(result)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getRebateItemById ({ commit, getters }, itemId) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${getters.programId}/rebateItem/${itemId}`)
        .then(response => {
          commit('SUCCESS')
          commit('SET_ITEM', response.data.item)
          resolve(response.data.item)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  updateRebateItemById ({ commit, getters }, payload) {
    // updatedFields { fieldName: 'value', fieldName2: 'value2'}
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${getters.programId}/rebateItem/${payload.itemId}`, payload.updatedFields)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.item)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  setProgram ({ commit }, program) {
    commit('SET_PROGRAM', program)
  }
}

const getters = {
  program: state => {
    return state.program || {}
  },
  programId: state => {
    return state.program ? state.program._id : ''
  },
  disabledPrograms: state => {
    return state.programs.filter(program => program.disabled)
  },
  enabledPrograms: state => {
    return state.programs.filter(program => !program.disabled)
  },
  approvedReceiptItems: state => {
    return state.receiptItems.filter(item => item.approved)
  },
  unapprovedReceiptItems: state => {
    return state.receiptItems.filter(item => !item.approved && !item.denied)
  },
  approvedReceipts: (state) => {
    return state.receipts.filter(receipt => receipt.approved)
  },
  unapprovedReceipts: (state) => {
    return state.receipts.filter(receipt => !receipt.approved && receipt.finished)
  },
  completedTrainingsCount: state => {
    if (!state.program.userLoyaltyPrograms) return 0
    return state.program.userLoyaltyPrograms
      .reduce((count, userLoyaltyProgram) => {
        count += userLoyaltyProgram.completedTrainings.length || 0
        return count
      }, 0)
  },
  rewardItems: state => {
    return state.program.rewardItems || []
  },
  trainings: state => {
    return state.program.loyaltyProgramTrainings
  },
  usersRequireApproval: state => {
    return state.program.usersRequireApproval !== undefined
      ? state.program.usersRequireApproval
      : true
  },
  completedTrainings: (state, getters) => {
    const trainings = getters.trainings
    if (!trainings) {
      return []
    }
    return state.program.userLoyaltyPrograms
      .filter(userLoyaltyProgram => userLoyaltyProgram.completedTrainings.length > 0)
      .reduce((trainingData, userLoyaltyProgram) => {
        userLoyaltyProgram.completedTrainings.forEach((training) => {
          const moduleName = trainings.find(t => t._id.toString() === training.trainingId.toString()).moduleName
          if (trainingData.hasOwnProperty(moduleName)) {
            trainingData[moduleName].push({
              moduleName,
              username: userLoyaltyProgram.user.username
            })
          } else {
            trainingData[moduleName] = [{
              moduleName,
              username: userLoyaltyProgram.user.username
            }]
          }
        })
        return trainingData
      }, {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
